import React from "react";
import List22 from "../../../reusableComponents/Lists/list22"
import Button from "../../../reusableComponents/buttons/button22";
import { useNavigate } from "react-router-dom";

// This function works fine - it creates data URLs without ReactDOMServer
const getIconPlaceholder = (iconType) => {
  const colors = {
    "Fees": "#2196F3",
    "Exam Results": "#4CAF50",
    "Quizzes": "#FF9800",
    "Time Table": "#9C27B0"
  };

  const color = colors[iconType] || "#2196F3";

  return {
    src: `data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='48' height='48' rx='8' fill='%23F5F5F5'/%3E%3Ccircle cx='24' cy='24' r='12' fill='${color.replace('#', '%23')}'/%3E%3C/svg%3E`,
    alt: iconType
  };
};

const StudentPortalList = () => {
  const navigate = useNavigate();
  // Student portal data using icon placeholders that List22 can handle
  const studentItems = [
    // {
    //   image: getIconPlaceholder("Fees"),
    //   label: "Label",
    //   showLabel: false,
    //   title: "Fees",
    //   showDescription: false,
    // },
    // {
    //   image: getIconPlaceholder("Exam Results"),
    //   label: "Label",
    //   showLabel: false,
    //   title: "Exam Results",
    //   showDescription: false,
    // },
    {
      image: getIconPlaceholder("Quizzes"),
      label: "Label",
      showLabel: false,
      title: "Quizzes",
      showDescription: false,
    },
    {
      image: getIconPlaceholder("Time Table"),
      label: "Label",
      showLabel: false,
      title: "Time Table",
      showDescription: false
    }
  ];

  // Render View buttons with different onClick handlers based on item
  const renderRightComponent = (item, index) => {
    // Define different onClick behaviors based on item title
    const getClickHandler = () => {
      switch (item.title) {
        // case "Fees":
        //   return () => {
        //     console.log(`Navigating to fees`);
        //     navigate('/profile/fees');
        //   };
        // case "Exam Results":
        //   return () => console.log(`Viewing exam results`);
        case "Quizzes":
          return () => {
            console.log(`Navigating to quizzes`);
            navigate('/learning/quiz');
          };
        case "Time Table":
          return () => {
            console.log(`Navigating to timetable`);
            navigate('/learning/timetable');
          };
        default:
          return () => console.log(`Viewing ${item.title}`);
      }
    };

    // Return consistent View button with different onClick handlers
    return (
      <Button
        text="View"
        state="Disabled"
        type="Secondary"
        variant="Default"
        onClick={getClickHandler()}
        className="ml-2"
      />
    );
  };

  return (
    <div className="max-w-full sm:grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <List22
        items={studentItems}
        width="w-full"
        gap={2}
        renderRightComponent={renderRightComponent}
        className="space-y-4 sm:space-y-0 sm:col-span-2 lg:col-span-4"
      />
    </div>
  );
};

export default StudentPortalList;